import { getResource, sendForSuccess } from "../api/http";

// Privacy policy
export function getPolicy() {
  return getResource("/api/settings/get-policy", {
    select: (data) => data.savedData,
    fallback: [],
  });
}

export function addPolicy(obj) {
  return sendForSuccess("post", "/api/settings/set-policy", obj);
}

// Terms & conditions
export function getTC() {
  return getResource("/api/settings/get-terms", {
    select: (data) => data.savedData,
    fallback: [],
  });
}

export function addTC(obj) {
  return sendForSuccess("post", "/api/settings/set-terms", obj);
}

// About us page
export function getAboutInfo() {
  return getResource("/api/admin/about/afo");
}

export function postAboutDetails(obj) {
  return sendForSuccess("post", "/api/admin/about-details/afo", obj);
}

export function postContactDetails(obj) {
  return sendForSuccess("post", "/api/admin/contact-details/afo", obj);
}

export function postTeamData(obj) {
  return sendForSuccess("post", "/api/admin/about-team-member/afo", obj);
}
